'use client'

import './globals.css'
import { interactiveClasses } from '@/lib/interaction-classes'
import { cn } from '@/lib/utils'

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
    return (
        <html lang='en'>
            <body className='min-h-screen bg-background px-6 py-16 font-sans text-foreground antialiased'>
                <div className='mx-auto max-w-md space-y-4 text-center'>
                    <h1 className='text-2xl font-semibold text-foreground'>Unexpected error</h1>
                    <p className='text-sm text-muted-foreground'>{error.message}</p>
                    <button
                        type='button'
                        onClick={reset}
                        className={cn(
                            'rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:opacity-90',
                            interactiveClasses
                        )}
                    >
                        Try again
                    </button>
                </div>
            </body>
        </html>
    )
}
